export default "__VITE_ASSET__CRgBGHo1__"